{
  "main": {
    "pt-BR": {
      "identity": {
        "version": {
          "_number": "$Revision: 14842 $",
          "_cldrVersion": "35.1"
        },
        "language": "pt"
      },
      "dates": {
        "calendars": {
          "gregorian": {
            "months": {
              "format": {
                "abbreviated": {
                  "1": "jan",
                  "2": "fev",
                  "3": "mar",
                  "4": "abr",
                  "5": "mai",
                  "6": "jun",
                  "7": "jul",
                  "8": "ago",
                  "9": "set",
                  "10": "out",
                  "11": "nov",
                  "12": "dez"
                },
                "narrow": {
                  "1": "J",
                  "2": "F",
                  "3": "M",
                  "4": "A",
                  "5": "M",
                  "6": "J",
                  "7": "J",
                  "8": "A",
                  "9": "S",
                  "10": "O",
                  "11": "N",
                  "12": "D"
                },
                "wide": {
                  "1": "janeiro",
                  "2": "fevereiro",
                  "3": "março",
                  "4": "abril",
                  "5": "maio",
                  "6": "junho",
                  "7": "julho",
                  "8": "agosto",
                  "9": "setembro",
                  "10": "outubro",
                  "11": "novembro",
                  "12": "dezembro"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "1": "jan",
                  "2": "fev",
                  "3": "mar",
                  "4": "abr",
                  "5": "mai",
                  "6": "jun",
                  "7": "jul",
                  "8": "ago",
                  "9": "set",
                  "10": "out",
                  "11": "nov",
                  "12": "dez"
                },
                "narrow": {
                  "1": "J",
                  "2": "F",
                  "3": "M",
                  "4": "A",
                  "5": "M",
                  "6": "J",
                  "7": "J",
                  "8": "A",
                  "9": "S",
                  "10": "O",
                  "11": "N",
                  "12": "D"
                },
                "wide": {
                  "1": "janeiro",
                  "2": "fevereiro",
                  "3": "março",
                  "4": "abril",
                  "5": "maio",
                  "6": "junho",
                  "7": "julho",
                  "8": "agosto",
                  "9": "setembro",
                  "10": "outubro",
                  "11": "novembro",
                  "12": "dezembro"
                }
              }
            },
            "days": {
              "format": {
                "abbreviated": {
                  "sun": "dom",
                  "mon": "seg",
                  "tue": "ter",
                  "wed": "qua",
                  "thu": "qui",
                  "fri": "sex",
                  "sat": "sáb"
                },
                "narrow": {
                  "sun": "D",
                  "mon": "S",
                  "tue": "T",
                  "wed": "Q",
                  "thu": "Q",
                  "fri": "S",
                  "sat": "S"
                },
                "short": {
                  "sun": "dom",
                  "mon": "seg",
                  "tue": "ter",
                  "wed": "qua",
                  "thu": "qui",
                  "fri": "sex",
                  "sat": "sáb"
                },
                "wide": {
                  "sun": "domingo",
                  "mon": "segunda-feira",
                  "tue": "terça-feira",
                  "wed": "quarta-feira",
                  "thu": "quinta-feira",
                  "fri": "sexta-feira",
                  "sat": "sábado"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "sun": "dom",
                  "mon": "seg",
                  "tue": "ter",
                  "wed": "qua",
                  "thu": "qui",
                  "fri": "sex",
                  "sat": "sáb"
                },
                "narrow": {
                  "sun": "D",
                  "mon": "S",
                  "tue": "T",
                  "wed": "Q",
                  "thu": "Q",
                  "fri": "S",
                  "sat": "S"
                },
                "short": {
                  "sun": "dom",
                  "mon": "seg",
                  "tue": "ter",
                  "wed": "qua",
                  "thu": "qui",
                  "fri": "sex",
                  "sat": "sáb"
                },
                "wide": {
                  "sun": "domingo",
                  "mon": "segunda-feira",
                  "tue": "terça-feira",
                  "wed": "quarta-feira",
                  "thu": "quinta-feira",
                  "fri": "sexta-feira",
                  "sat": "sábado"
                }
              }
            },
            "quarters": {
              "format": {
                "abbreviated": {
                  "1": "T1",
                  "2": "T2",
                  "3": "T3",
                  "4": "T4"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                "wide": {
                  "1": "1º trimestre",
                  "2": "2º trimestre",
                  "3": "3º trimestre",
                  "4": "4º trimestre"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "1": "T1",
                  "2": "T2",
                  "3": "T3",
                  "4": "T4"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                "wide": {
                  "1": "1º trimestre",
                  "2": "2º trimestre",
                  "3": "3º trimestre",
                  "4": "4º trimestre"
                }
              }
            },
            "dayPeriods": {
              "format": {
                "abbreviated": {
                  "midnight": "meia-noite",
                  "am": "AM",
                  "noon": "meio-dia",
                  "pm": "PM",
                  "morning1": "da manhã",
                  "afternoon1": "da tarde",
                  "evening1": "da noite",
                  "night1": "da madrugada"
                },
                "narrow": {
                  "midnight": "meia-noite",
                  "am": "AM",
                  "noon": "meio-dia",
                  "pm": "PM",
                  "morning1": "da manhã",
                  "afternoon1": "da tarde",
                  "evening1": "da noite",
                  "night1": "da madrugada"
                },
                "wide": {
                  "midnight": "meia-noite",
                  "am": "AM",
                  "noon": "meio-dia",
                  "pm": "PM",
                  "morning1": "da manhã",
                  "afternoon1": "da tarde",
                  "evening1": "da noite",
                  "night1": "da madrugada"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "midnight": "meia-noite",
                  "am": "AM",
                  "noon": "meio-dia",
                  "pm": "PM",
                  "morning1": "manhã",
                  "afternoon1": "tarde",
                  "evening1": "noite",
                  "night1": "madrugada"
                },
                "narrow": {
                  "midnight": "meia-noite",
                  "am": "AM",
                  "noon": "meio-dia",
                  "pm": "PM",
                  "morning1": "manhã",
                  "afternoon1": "tarde",
                  "evening1": "noite",
                  "night1": "madrugada"
                },
                "wide": {
                  "midnight": "meia-noite",
                  "am": "AM",
                  "noon": "meio-dia",
                  "pm": "PM",
                  "morning1": "manhã",
                  "afternoon1": "tarde",
                  "evening1": "noite",
                  "night1": "madrugada"
                }
              }
            },
            "eras": {
              "eraNames": {
                "0": "antes de Cristo",
                "0-alt-variant": "antes da Era Comum",
                "1": "depois de Cristo",
                "1-alt-variant": "Era Comum"
              },
              "eraAbbr": {
                "0": "a.C.",
                "0-alt-variant": "AEC",
                "1": "d.C.",
                "1-alt-variant": "EC"
              },
              "eraNarrow": {
                "0": "a.C.",
                "0-alt-variant": "AEC",
                "1": "d.C.",
                "1-alt-variant": "EC"
              }
            },
            "dateFormats": {
              "full": "EEEE, d 'de' MMMM 'de' y",
              "long": "d 'de' MMMM 'de' y",
              "medium": "d 'de' MMM 'de' y",
              "short": "dd/MM/y"
            },
            "timeFormats": {
              "full": "HH:mm:ss zzzz",
              "long": "HH:mm:ss z",
              "medium": "HH:mm:ss",
              "short": "HH:mm"
            },
            "dateTimeFormats": {
              "full": "{1} {0}",
              "long": "{1} {0}",
              "medium": "{1} {0}",
              "short": "{1} {0}",
              "availableFormats": {
                "Bh": "h B",
                "Bhm": "h:mm B",
                "Bhms": "h:mm:ss B",
                "d": "d",
                "E": "ccc",
                "EBhm": "E h:mm B",
                "EBhms": "E h:mm:ss B",
                "Ed": "E, d",
                "Ehm": "E, h:mm a",
                "EHm": "E, HH:mm",
                "Ehms": "E, h:mm:ss a",
                "EHms": "E, HH:mm:ss",
                "Gy": "y G",
                "GyMMM": "MMM 'de' y G",
                "GyMMMd": "d 'de' MMM 'de' y G",
                "GyMMMEd": "E, d 'de' MMM 'de' y G",
                "h": "h a",
                "H": "HH",
                "hm": "h:mm a",
                "Hm": "HH:mm",
                "hms": "h:mm:ss a",
                "Hms": "HH:mm:ss",
                "hmsv": "h:mm:ss a v",
                "Hmsv": "HH:mm:ss v",
                "hmv": "h:mm a v",
                "Hmv": "HH:mm v",
                "M": "L",
                "Md": "d/M",
                "MEd": "E, dd/MM",
                "MMdd": "dd/MM",
                "MMM": "LLL",
                "MMMd": "d 'de' MMM",
                "MMMEd": "E, d 'de' MMM",
                "MMMMd": "d 'de' MMMM",
                "MMMMEd": "E, d 'de' MMMM",
                "MMMMW-count-one": "W'ª' 'semana' 'de' MMMM",
                "MMMMW-count-other": "W'ª' 'semana' 'de' MMMM",
                "ms": "mm:ss",
                "y": "y",
                "yM": "MM/y",
                "yMd": "dd/MM/y",
                "yMEd": "E, dd/MM/y",
                "yMM": "MM/y",
                "yMMM": "MMM 'de' y",
                "yMMMd": "d 'de' MMM 'de' y",
                "yMMMEd": "E, d 'de' MMM 'de' y",
                "yMMMM": "MMMM 'de' y",
                "yMMMMd": "d 'de' MMMM 'de' y",
                "yMMMMEd": "E, d 'de' MMMM 'de' y",
                "yQQQ": "QQQ 'de' y",
                "yQQQQ": "QQQQ 'de' y",
                "yw-count-one": "w'ª' 'semana' 'de' Y",
                "yw-count-other": "w'ª' 'semana' 'de' Y"
              },
              "appendItems": {
                "Day": "{0} ({2}: {1})",
                "Day-Of-Week": "{0} {1}",
                "Era": "{1} {0}",
                "Hour": "{0} ({2}: {1})",
                "Minute": "{0} ({2}: {1})",
                "Month": "{0} ({2}: {1})",
                "Quarter": "{0} ({2}: {1})",
                "Second": "{0} ({2}: {1})",
                "Timezone": "{0} {1}",
                "Week": "{0} ({2}: {1})",
                "Year": "{1} {0}"
              },
              "intervalFormats": {
                "intervalFormatFallback": "{0} - {1}",
                "Bh": {
                  "B": "h B – h B",
                  "h": "h – h B"
                },
                "Bhm": {
                  "B": "h:mm B – h:mm B",
                  "h": "h:mm – h:mm B",
                  "m": "h:mm – h:mm B"
                },
                "d": {
                  "d": "d – d"
                },
                "Gy": {
                  "G": "G y – G y",
                  "y": "G y – y"
                },
                "GyM": {
                  "G": "GGGGG MM/y – GGGGG MM/y",
                  "M": "GGGGG MM/y – MM/y",
                  "y": "GGGGG MM/y – MM/y"
                },
                "GyMd": {
                  "d": "GGGGG dd/MM/y – dd/MM/y",
                  "G": "GGGGG dd/MM/y – GGGGG dd/MM/y",
                  "M": "GGGGG dd/MM/y – dd/MM/y",
                  "y": "GGGGG dd/MM/y – dd/MM/y"
                },
                "GyMEd": {
                  "d": "GGGGG E dd/MM/y – dd/MM/y",
                  "G": "GGGGG E dd/MM/y – GGGGG E dd/MM/y",
                  "M": "GGGGG E dd/MM/y – E dd/MM/y",
                  "y": "GGGGG E dd/MM/y – E dd/MM/y"
                },
                "GyMMM": {
                  "G": "G MMM y – G MMM y",
                  "M": "G MMM y – MMM",
                  "y": "G MMM y – MMM y"
                },
                "GyMMMd": {
                  "d": "G d – d 'de' MMM y",
                  "G": "G d 'de' MMM y – G d 'de' MMM y",
                  "M": "G d 'de' MMM y – d 'de' MMM",
                  "y": "G d 'de' MMM y – d 'de' MMM y"
                },
                "GyMMMEd": {
                  "d": "G E, d 'de' MMM y – E, d 'de' MMM",
                  "G": "G E, d 'de' MMM y – G E, d 'de' MMM y",
                  "M": "G E, d 'de' MMM y – E, d 'de' MMM",
                  "y": "G E, d 'de' MMM y – E, d 'de' MMM y"
                },
                "h": {
                  "a": "h a – h a",
                  "h": "h – h a"
                },
                "H": {
                  "H": "HH'h' - HH'h'"
                },
                "hm": {
                  "a": "h:mm a – h:mm a",
                  "h": "h:mm – h:mm a",
                  "m": "h:mm – h:mm a"
                },
                "Hm": {
                  "H": "HH:mm – HH:mm",
                  "m": "HH:mm – HH:mm"
                },
                "hmv": {
                  "a": "h:mm a – h:mm a v",
                  "h": "h:mm – h:mm a v",
                  "m": "h:mm – h:mm a v"
                },
                "Hmv": {
                  "H": "HH:mm – HH:mm v",
                  "m": "HH:mm – HH:mm v"
                },
                "hv": {
                  "a": "h a – h a v",
                  "h": "h – h a v"
                },
                "Hv": {
                  "H": "HH – HH v"
                },
                "M": {
                  "M": "M – M"
                },
                "Md": {
                  "d": "dd/MM – dd/MM",
                  "M": "dd/MM – dd/MM"
                },
                "MEd": {
                  "d": "E, dd/MM – E, dd/MM",
                  "M": "E, dd/MM – E, dd/MM"
                },
                "MMM": {
                  "M": "MMM – MMM"
                },
                "MMMd": {
                  "d": "d – d 'de' MMM",
                  "M": "d 'de' MMM – d 'de' MMM"
                },
                "MMMEd": {
                  "d": "E, d – E, d 'de' MMM",
                  "M": "E, d 'de' MMM – E, d 'de' MMM"
                },
                "y": {
                  "y": "y – y"
                },
                "yM": {
                  "M": "MM/y – MM/y",
                  "y": "MM/y – MM/y"
                },
                "yMd": {
                  "d": "dd/MM/y – dd/MM/y",
                  "M": "dd/MM/y – dd/MM/y",
                  "y": "dd/MM/y – dd/MM/y"
                },
                "yMEd": {
                  "d": "E, dd/MM/y – E, dd/MM/y",
                  "M": "E, dd/MM/y – E, dd/MM/y",
                  "y": "E, dd/MM/y – E, dd/MM/y"
                },
                "yMMM": {
                  "M": "MMM – MMM 'de' y",
                  "y": "MMM 'de' y – MMM 'de' y"
                },
                "yMMMd": {
                  "d": "d – d 'de' MMM 'de' y",
                  "M": "d 'de' MMM – d 'de' MMM 'de' y",
                  "y": "d 'de' MMM 'de' y – d 'de' MMM 'de' y"
                },
                "yMMMEd": {
                  "d": "E, d – E, d 'de' MMM 'de' y",
                  "M": "E, d 'de' MMM – E, d 'de' MMM 'de' y",
                  "y": "E, d 'de' MMM 'de' y – E, d 'de' MMM 'de' y"
                },
                "yMMMM": {
                  "M": "MMMM – MMMM 'de' y",
                  "y": "MMMM 'de' y – MMMM 'de' y"
                }
              }
            }
          }
        }
      }
    }
  }
}
